import { EditableFieldView } from "@softmax/product-ux/editor";
import type { EditableFieldViewProps } from "@softmax/product-ux/editor";
import { useEditModeMaybe } from "../use-edit-mode-maybe";

export function EditableField(
  props: Omit<EditableFieldViewProps, "editing" | "loading">,
) {
  const mode = useEditModeMaybe();
  return (
    <EditableFieldView
      {...props}
      editing={mode?.editing ?? false}
      loading={mode ? !mode.editor.loaded : false}
    />
  );
}
